export const proxyUrls: string[] = ['api', 'settings', 'qrcode'];
